module.exports = __webpack_public_path__ + "img/logo-aqu.6cc27101.png";